<template>
        <div class="warp">
        <breadcrumb :back="true" :crubList="[{name:'成果展示管理'},{name:'成果展示列表',goback:true},{name:'成果展示详情'}]" :title="'成果展示详情'"/>
            <!-- 主体内容 -->
            <!-- 用户明细 -->
            <div class="box">
               <el-card class="basic box_card" header="基本信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">公告标题：</div>
                            <div class="content">{{detailInfo.title || '--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name"> 来源：</div>
                            <div class="content">{{detailInfo.source || '--'}}</div>
                        </div>
                  </el-col>
                 </el-row>
                 <el-row>
                  <el-col :span="24">
                    <div class="child">
                            <div class="name">公告详情：</div>
                            <div class="content" v-html="detailInfo.content"></div>
                        </div>
                  </el-col>
                  </el-row>
                 <el-row>
                  
                  <el-col :span="24">
                   <div class="attachment">
                            <div class="name">附件：</div>
                            <ul class="content" v-if="detailInfo.fileList && detailInfo.fileList.length !== 0">
                                <li v-for="(item,i) in detailInfo.fileList" :key="i">
                                    <span>{{item.fileName}}</span><i class="el-icon-download" @click="downLoad(item)"></i>
                                </li>
                            </ul>
                        </div>
                  </el-col>
                  
                </el-row>
              </el-card>
              <el-card class="basic box_card mt16" header="发布信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">发布账号：</div>
                            <div class="content">{{detailInfo.createUserName ||  '--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">发布时间：</div>
                            <div class="content">{{detailInfo.createTime ||  '--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">更新账号：</div>
                            <div class="content">{{detailInfo.modifyUserName || '--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">更新时间：</div>
                            <div class="content">{{detailInfo.updateTime || '--'}}</div>
                        </div>
                  </el-col>
                </el-row>
              </el-card>
              
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import {onDownload} from "@/utils/common";
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            tab:'1',//选项卡
            id:'',//详情id
            detailInfo:{
                id: void 0,
                fileList:[],
                content: void 0
            },
      ishide:false,
        }
    },
    methods:{
        
        //获取数据
        async getData(){
         const {code,data,msg} = await this.$axiosc.get('/backstage/announcement/findAnnouncementDetails/'+this.id)
          if (code == 200) {            
              this.detailInfo = data;
          } else {
              this.$alert(msg)
          }
        },
        downLoad:function({fileName,filePath}){
           const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
        },
    },
    created(){        
        this.id=this.$route.params.id;
    },
    mounted(){
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
.warp{
    height:96%;
     overflow-x: hidden;
     overflow-y: auto;
}
.box{
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col{
    margin: 10px 0;
  }
  .child{
    color:#595959;
  }
}
.main{
  background: transparent !important;
  padding:0 !important;
}
</style>